"use client"

import Title from "@/components/common/Typography/Title"
import { Discount, TypeStoreDetail } from "@/lib/redux/features/store/type"
import { formatCurrencyUSD } from "@/utils/app/formatCurrencyUSD"
import { Button, Col, ConfigProvider, Row, Typography } from "antd"
import PromoDuration from "./PromoDuration"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faX } from "@fortawesome/free-solid-svg-icons"
import { useState } from "react"

const BasicLayoutPromoBar = ({ store, discount }: { store: TypeStoreDetail, discount: Discount }) => {
  const [shown, setShown] = useState<boolean>(true)

  if (!shown) return <></>

  return (
    <ConfigProvider
      theme={{
        token: {
          colorText: store.root_layout_promo_bar.color
        }
      }}
    >
      <Row
        className="basic_layout--promo_bar"
        justify='center'
        style={{
          backgroundColor: store.root_layout_promo_bar.bg_color,
          color: store.root_layout_promo_bar.color,
          backgroundImage: `url("${store.root_layout_promo_bar.bg_image}")`,
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
          paddingBlock: '1rem',
          rowGap: '0.5rem',
          ...(store.root_layout_promo_bar.bg_mode === "fill"
            ? {}
            : {
              backgroundRepeat: 'repeat',
              backgroundImage: `url("${store.root_layout_promo_bar.bg_image}")`,
              backgroundPosition: 'center center',
              backgroundSize: `${store.root_layout_promo_bar.bg_width / 10}rem ${store.root_layout_promo_bar.bg_height / 10}rem`
            })
        }}
        align='middle'
      >
        <Col>
          <Title level={5} style={{ margin: 0, marginRight: 10, fontSize: '1.6rem' }}>
            Hurry! Sale ends in
          </Title>
        </Col>
        <Col style={{ marginRight: 10 }}>
          <PromoDuration onEnded={() => setShown(false)} discount={discount} />
        </Col>
        <Col>
          <Title level={5} style={{ margin: 0 }}>
            {discount.discount_type === 'amount' ? `Save ${formatCurrencyUSD.format(parseFloat(discount.discount_values || "0"))} Today!` : `Grab up to ${parseFloat(discount.discount_values || "0")}% Off!`}
          </Title>
        </Col>
        <Button
          onClick={() => {
            setShown(false)
            window.document.body.querySelector(".basic_layout")?.classList.remove("basic_layout--has_promo")
          }}
          style={{ position: 'absolute', top: '0.5rem', right: '0.5rem', height: '2rem', width: '2rem', fontSize: '1rem' }}
          icon={<FontAwesomeIcon icon={faX} />}
        />
      </Row>
    </ConfigProvider>
  )
}

export default BasicLayoutPromoBar